<!--
 * @Author: quwandong
 * @Date: 2022-05-17 09:21:57
 * @LastEditors: quwandong
 * @LastEditTime: 2022-05-19 15:58:44
 * @FilePath: \motion\src\views\BdOrder\detail.vue
 * @Description: 北斗订单详情
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main" v-loading="loading">
      <div class="plate">
        <!-- 状态 -->
        <div class="plate-status">
          <div class="top">
            <span>
              订单编号：{{
                order.orderNumber
              }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;下单时间：{{
                order.createTime
              }}
            </span>
          </div>
          <div class="status">
            <div class="status-cur">
              <template v-if="order.statusFlag == 2">
                <img src="@/assets/order_status_bepaid.png" />
                <p>待付款</p>
              </template>
              <template v-else-if="order.statusFlag == 3">
                <img src="@/assets/order_status_fahuo.png" />
                <p>待发货</p>
              </template>
              <template v-if="order.statusFlag == 4">
                <img src="@/assets/order_status_delivery.png" />
                <p>待收货</p>
              </template>
              <template v-if="order.statusFlag == 5">
                <img src="@/assets/order_status_end.png" />
                <p>订单完成</p>
              </template>
              <template v-if="order.statusFlag == 6">
                <img src="@/assets/order_status_clouse.png" />
                <p style="color: #888888">订单关闭</p>
              </template>
            </div>
            <div class="status-list">
              <template v-if="order.statusFlag == 6">
                <el-steps align-center :active="2">
                  <el-step
                    title="下单"
                    icon="el-icon-success"
                    :description="order.createTime"
                  ></el-step>
                  <el-step
                    title="关闭"
                    icon="el-icon-error"
                    description=""
                  ></el-step>
                </el-steps>
              </template>
              <template v-else>
                <el-steps align-center :active="stepActive">
                  <el-step
                    title="下单"
                    :icon="orderStatusTime.uptTime2 ? 'el-icon-success' : ''"
                    :description="orderStatusTime.uptTime2"
                  ></el-step>
                  <el-step
                    title="支付"
                    :icon="orderStatusTime.uptTime3 ? 'el-icon-success' : ''"
                    :description="orderStatusTime.uptTime3 || ''"
                  ></el-step>
                  <el-step
                    title="发货"
                    :icon="orderStatusTime.uptTime4 ? 'el-icon-success' : ''"
                    :description="orderStatusTime.uptTime4 || ''"
                  ></el-step>
                  <el-step
                    title="收货"
                    :icon="orderStatusTime.uptTime5 ? 'el-icon-success' : ''"
                    :description="orderStatusTime.uptTime5 || ''"
                  ></el-step>
                  <el-step
                    title="完成"
                    :icon="orderStatusTime.uptTime6 ? 'el-icon-success' : ''"
                    :description="orderStatusTime.uptTime6"
                  ></el-step>
                </el-steps>
              </template>
            </div>
          </div>
        </div>
        <!-- 商品 -->
        <div class="plate-product">
          <div class="pro-table">
            <div class="tr head">
              <div class="td">商品</div>
              <div class="td">价格</div>
              <div class="td">数量</div>
              <div class="td">小计</div>
            </div>
            <div
              class="tr"
              v-for="item in order.bdsOrderProductDetilDtos"
              :key="item.id"
            >
              <div class="td">
                <div class="thumb">
                  <img :src="item.bdsProductDto.thumb" />
                </div>
                <div class="info">
                  <p class="tit">{{ item.bdsProductDto.title }}</p>
                  <p>{{ item.bdsProductDto.spec }}</p>
                </div>
              </div>
              <div class="td">￥{{ item.bdsProductDto.price }}</div>
              <div class="td">{{ item.number }}</div>
              <div class="td">￥{{ item.total }}</div>
            </div>
          </div>
          <div class="total">
            总计：<span class="pri">¥{{ order.saleAmountTotal }}</span>
          </div>
        </div>
      </div>
      <div class="plate plate-order">
        <div class="item">
          <label>支付方式</label>
          <p>
            <template v-if="order.payType == 10">
              <img src="@/assets/wx.png" />&nbsp;微信扫码支付
            </template>
            <template v-else-if="order.payType == 15">银行打款</template>
            <template v-else-if="order.payType == 20">货到付款</template>
          </p>
        </div>
        <div class="item">
          <label>运费</label>
          <p>
            <template v-if="order.sendMethod == 10">免运费</template>
            <template v-else-if="order.sendMethod == 15">到付</template>
          </p>
        </div>
        <div class="item address">
          <label>收货地址</label>
          <p>
            {{ order.bdsOrderAddressInvoiceEntities.addressName }}/{{
              order.bdsOrderAddressInvoiceEntities.addressMobile
            }}&nbsp;&nbsp;{{
              order.bdsOrderAddressInvoiceEntities.addressFullName
            }}
          </p>
        </div>
        <div class="item">
          <label>发票信息</label>
          <p>
            {{
              order.isInvoice == 0
                ? '不需要发票'
                : order.bdsOrderAddressInvoiceEntities.invoiceTitle
            }}
          </p>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import { formatDate } from '@/utils/formatDate'
export default {
  data() {
    return {
      id: '', //订单id
      order: { bdsOrderAddressInvoiceEntities: {} }, //订单信息
      stepActive: 1,
      orderStatusTime: {},
      loading: false,
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getOrderDetail()
  },
  methods: {
    // 获取订单详情
    async getOrderDetail() {
      try {
        this.loading = true
        const res = await this.$http.bdOrder.getOrderDetailById({ id: this.id })
        const order = res.data

        order.createTime = formatDate(
          new Date(order.createTime),
          'yyyy-MM-dd hh:mm:ss'
        )
        this.stepActive = order.statusFlag - 1
        this.order = order
        order.bdsOrderStatusEntitys.forEach((item) => {
          this.orderStatusTime[`uptTime${item.statusFlag}`] = formatDate(
            new Date(item.uptTime),
            'yyyy-MM-dd hh:mm:ss'
          )
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  background: transparent !important;
  padding: 0 !important;
  .plate {
    background: #ffffff;
  }
  .plate-status {
    padding: 0 20px;
    .top {
      height: 70px;
      line-height: 70px;
      font-size: 16px;
      color: #5f6868;
      display: flex;
      justify-content: space-between;
      .time-down {
        color: #f20000;
      }
    }
    .status {
      display: flex;
      align-items: center;
      padding-top: 20px;
      padding-bottom: 10px;
      .status-cur {
        flex-shrink: 0;
        width: 190px;
        text-align: center;
        border-right: 1px solid #e7e7e7;
        font-size: 20px;
        color: #018388;
        font-weight: bold;
      }
      .status-list {
        margin-left: 20px;
        margin: 0 auto;
      }
    }
  }
  .plate-product {
    padding: 0 20px;
    margin-top: 20px;
    .pro-table {
      border: 1px solid #dfe7eb;
      .tr {
        display: flex;
        align-items: center;
        text-align: center;
        &:not(:last-child) {
          border-bottom: 1px solid #dfe7eb;
        }
        &.head {
          height: 50px;
          background-color: #f1f5f8;
          color: #5f6868;
          font-size: 16px;
          border-bottom: none;
        }
        .td {
          font-size: 16px;
          color: #333333;

          &:nth-child(1) {
            width: 40%;
            text-align: left;
            display: flex;
            align-items: center;
            padding-left: 30px;
            box-sizing: border-box;
            .thumb {
              width: 100px;
              height: 100px;
              border-radius: 4px;
              border: solid 1px #efefef;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 16px 30px 16px 0;
              flex-shrink: 0;
              img {
                max-width: 98%;
                max-height: 98%;
              }
            }
            p {
              color: #888888;
              margin: 5px 0;
              &.tit {
                font-size: 18px;
                color: #222222;
              }
            }
          }
          &:nth-child(2) {
            width: 17.5%;
          }
          &:nth-child(3) {
            width: 20%;
          }
          &:nth-child(4) {
            width: 17.5%;
          }
          &:nth-child(5) {
            width: 5%;
          }
          .el-icon-delete {
            color: #888888;
          }
        }
      }
    }
    .total {
      height: 70px;
      line-height: 70px;
      text-align: right;
      color: #333333;
      font-size: 18px;
      .pri {
        color: #f64d12;
        font-size: 28px;
        font-weight: bold;
      }
    }
  }
  .plate-order {
    padding: 10px 30px;
    margin-top: 20px;
    .item {
      display: flex;
      font-size: 18px;
      color: #333333;
      padding: 10px 0;
      label {
        color: #222222;
        font-weight: bold;
        width: 90px;
        flex-shrink: 0;
      }
    }
  }
}
::v-deep .el-steps {
  .el-step {
    min-width: 180px;
    .el-step__icon-inner[class*='el-icon']:not(.is-status) {
      font-size: 40px;
    }
    .el-step__line {
      top: 18.5px;
    }
    .el-step__icon {
      height: 40px;
      color: #018388;
      .el-icon-error {
        color: #ea4646;
      }
      &.is-text {
        width: 40px;
        height: 40px;
        border: 1px solid #018388;
        color: #018388;
        font-size: 16px;
      }
    }
    .el-step__title {
      font-size: 16px;
      color: #333333;
      font-weight: normal;
    }
    .el-step__description {
      font-size: 14px;
      color: #666666;
      padding: 0 10px;
    }
  }
}
</style>